export default {
    zedPage: {
        documentTitlePrefix: "GREA", // * préfix du titre affiché dans l'onglet du navigateur.
    },
    api_base_url_local: "http://grea.zedixi.local/apiz", // ! unused
    api_base_url_distant: "https://grea.zedixi.com/apiz", // ! unused
}
